import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 2104E4B3-3A34-44AE-B073-B041FDFE5D41
 * name arrow-down-right-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-right-bold.svg
 * tags
 * - Arrow 
 */
export const ArrowDownRightBoldIcon = createSvgIcon(<><path d="M10.5 3C14.64 3 18 6.36 18 10.5V13H22L16 20L10 13H14V10.5C14 8.57 12.43 7 10.5 7H3V3H10.5Z" /></>, 'ArrowDownRightBoldIcon');
export default ArrowDownRightBoldIcon